import * as State from 'components/desktop/_general/Input/TreeInput/TreeInputState';
import { useHandler } from 'hooks/useHandler';

export default function useTreeInputState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			setSearchTerm: rf.createReducer(State.setSearchTerm),
			setShowSuggested: rf.createReducer(State.setShowSuggested),
			focus: rf.createReducer(State.focus),
			blur: rf.createReducer(State.blur),
		},
	};
}

export type TreeInputHandlers = ReturnType<typeof useTreeInputState>['handlers'];
